/*
 * MDB shim for DatePicker
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activitiesModal.jsx
 */

import MUITextField from "@mui/material/TextField";

import React, { useState, useEffect } from "react";

export default function DatePicker({ value, getValue, onChange, label, ...rest }) {
    // Internal state to keep track of the picked date, so it shows after selection
    const [selectedDate, setSelectedDate] = useState(value || "");

    // Keep state in sync if the parent updates the value prop
    useEffect(() => {
        setSelectedDate(value || "");
    }, [value]);

    function handleChange(event) {
        const newValue = event.target.value;
        setSelectedDate(newValue);
        onChange?.(event);
        getValue?.(newValue);
    }

    return (
        <MUITextField
            type="date"
            label={label}
            value={selectedDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            {...rest}
        />
    );
}
